export const ShareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M3 14H5V19H19V14H21V21H3V14Z" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 1.58594L18.7072 8.29304L17.293 9.70726L13.0001 5.41436V17.0002H11.0001V5.41436L6.70718 9.70726L5.29297 8.29304L12.0001 1.58594Z" fill="currentColor"/>
    </svg>
  )
}
